import { render, staticRenderFns } from "./homeInvestorRelations.vue?vue&type=template&id=7d6597e3&scoped=true"
import script from "./homeInvestorRelations.vue?vue&type=script&lang=js"
export * from "./homeInvestorRelations.vue?vue&type=script&lang=js"
import style0 from "./homeInvestorRelations.vue?vue&type=style&index=0&id=7d6597e3&prod&lang=css"
import style1 from "./homeInvestorRelations.vue?vue&type=style&index=1&id=7d6597e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d6597e3",
  null
  
)

export default component.exports